module.exports = __webpack_public_path__ + "static/media/ethax_factory.cc5e93c8.png";